const mutations = {
  saveUserInfo (state, data) {
    Object.assign(state.userInfo, data)
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key]
        this._vm.$set(state.userInfo, key, element)
      }
    }
    if (JSON.stringify(data) === '{}') {
      for (const key in state.userInfo) {
        this._vm.$set(state.userInfo, key, null)
      }
    }
    this._vm.$set(state.userInfo, 'isregister', false)
    if (state.userInfo.id && state.userInfo.id.indexOf('TY') !== 0) {
      state.userInfo.isregister = true
    }
  },
  addUploadItem (state, item) {
    state.uploadListStatus = 'uploading'
    state.panoUploadList.push(item)
  },
  modelAddUploadItem (state, item) {
    state.modelUploadListStatus = 'uploading'
    state.modelUploadList.push(item)
  },
  removeUploadList (state, item) {
    state.modelUploadList = []
    state.panoUploadList = []
  },
  changUploadItem (state, payload) {
    let item = null
    if (payload.type === 'pano') {
      item = state.panoUploadList[payload.index]
    }
    if (payload.type === 'model') {
      item = state.modelUploadList[payload.index]
    }
    if (payload.data) {
      Object.assign(item.file.taskInfo, payload.data)
    } else {
      item.file.taskInfo[payload.key] = payload.value
    }
    if (payload.type === 'pano') {
      state.panoUploadList.splice(payload.index, 1, item)
    }
    if (payload.type === 'model') {
      state.modelUploadList.splice(payload.index, 1, item)
    }
  },
  changePanoDialogData (state, payload) {
    Object.assign(state.panoDialogData, payload)
  },
  changeUploadData (state, payload) {
    let index = payload.index
    if (!payload.index && payload.index !== 0) {
      index = state.panoUploadDatas.findIndex(function (item, index, arr) {
        return item.id === payload.data.id
      })
    }
    if (index === -1) {
      state.panoUploadDatas.push(payload.data)
    } else {
      let newData = Object.assign(state.panoUploadDatas[index], payload.data)
      state.panoUploadDatas.splice(index, 1, newData)
    }
  },
  delUploadItem (state, payload) {
    let index = state.panoUploadDatas.findIndex(function (item, index, arr) {
      return item.id === payload.data.id
    })
    if (index !== -1) {
      let newData = Object.assign(state.panoUploadDatas[index], payload.data)
      state.panoUploadDatas.splice(index, 1, newData)
    }
    let uploadImgIndex = state.panoUploadList.findIndex(function (item, index, arr) {
      return item.file.taskInfo.position === parseInt(payload.picId)
    })
    if (uploadImgIndex !== -1) {
      // this.$set(state.panoUploadList[uploadImgIndex].file.taskInfo, 'isdelete', true)
      state.panoUploadList[uploadImgIndex].file.taskInfo.isdelete = true
    }
  },
  createNewPano (state, payload) {
    state.newPanoCount++
    state.deviceType = payload.deviceType
  },
  createNewModel (state, payload) {
    state.newModel.newModelCount++
    state.newModel.processType = payload.processType
  },
  changeUploadStatus (state, data) {
    if (data.type === 'model') {
      state.modelUploadListStatus = data.status
      return
    }
    state.uploadListStatus = data.status
  }
  // upDatePanoDialogData (state, data) {
  //   state.upDatePanoDialogData
  // }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js